<template>
  <div class="flex items-center ml-5 my-8" style="width: 150px">
    <div>
      <i :class="['fas fa-exclamation-triangle', 'text-2xl', 'text-white']"></i>
    </div>
    <div class="logo text-white font-semibold text-base ml-6 text-left">
      <div @click="triggerOverlay" class="cursor-pointer">SOS</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      overLayOpen: false
    }
  },
  methods: {
    triggerOverlay() {
      this.$emit('openOverlay', (this.overLayOpen = true))
    }
  }
}
</script>

<style lang="scss" scoped>
.sideNav {
  transition: width 0.6s cubic-bezier(0.25, 0.45, 0.45, 0.95);
  width: 6.2rem;
  z-index: 111;
  position: absolute;
  display: block;

  &:hover {
    width: 15%;

    .logo {
      display: block;
    }
  }

  .logo {
    display: none;
  }
}
</style>
